import type { RadioGroupBooleanProps } from '@repo/design-system-kit';
import { RadioButtonBoolean, RadioGroupBoolean } from '@repo/design-system-kit';
import { type ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

const RADIO_GROUP_ID = 'pep-radio-group';

type GroupProps = Omit<
  RadioGroupBooleanProps,
  'children' | 'className' | 'label' | 'labelClassName'
>;

export interface PepRadioButtonProps extends GroupProps {
  className?: string;
  title?: string;
  subtitle?: string;
}

export function PepRadioButton({
  className,
  title,
  subtitle,
  ...props
}: PepRadioButtonProps): ReactNode {
  return (
    <div className={className} data-test-pep-section>
      <h2 className="body-standard mb-8" data-test-pep-title id={`${RADIO_GROUP_ID}-label`}>
        {title || <FormattedMessage id="customer-registration-kit.membership.info.pep-label" />}
      </h2>

      <p className="caption mb-8" data-test-pep-description>
        {subtitle || (
          <FormattedMessage id="customer-registration-kit.membership.info.pep-text-helper" />
        )}
      </p>

      <RadioGroupBoolean
        aria-labelledby={`${RADIO_GROUP_ID}-label`}
        data-test-pep-radio-group
        id={RADIO_GROUP_ID}
        {...props}
      >
        <RadioButtonBoolean className="body-standard" data-test-pep-yes value>
          <FormattedMessage id="customer-registration-kit.common.yes" />
        </RadioButtonBoolean>

        <RadioButtonBoolean className="body-standard" data-test-pep-no value={false}>
          <FormattedMessage id="customer-registration-kit.common.no" />
        </RadioButtonBoolean>
      </RadioGroupBoolean>
    </div>
  );
}
